<template>
  <div class="min-h-screen" id="home">
    <!-- <div class="" style="position: relative;">
      <div class="banner-swiper w-full">
        <div class="swiper-wrapper">
          <template>
            <div class="swiper-slide">
              <img @click="to('AI')" src="https://1312339042.vod-qcloud.com/70030745vodsh1312339042/537c5e225145403692739094240/CYBiEWfks20A.gif"
                style="image-rendering: pixelated;cursor: pointer;width: 100%;height:110vh;" />
              <div style="position: absolute;bottom: 240px;color: #fff;left: calc((100% - 1400px) / 2)">
                <div style="font-size: 48px;">AI大模型服务平台</div>
                <div style="font-size: 48px;">适配于DeepSeek大模型</div>
                <div style="font-size: 24px;margin-top: 50px;opacity: 0.8;">驱动企业智能化深度变革，释放数据价值，重塑业务增长引擎</div>
              </div>
            </div>
            <div class="swiper-slide">
              <img @click="to('solution')" src="https://1312339042.vod-qcloud.com/110f907evodcq1312339042/6e42255f5145403692736108235/kInNyHgwFLwA.gif"
                style="image-rendering: pixelated;cursor: pointer;width: 100%;height:110vh;" />
              <div style="position: absolute;bottom: 260px;color: #fff;left: calc((100% - 1400px) / 2)">
                <div style="font-size: 48px;">全场景定制开发解决方案</div>
                <div style="font-size: 24px;margin-top: 50px;opacity: 0.8;">敏捷开发快速迭代｜私有化+云端协同部署｜跨平台API深度集成</div>
                <div style="font-size: 24px;margin-top: 10px;opacity: 0.8;">AI+大数据中台搭建｜存量系统架构升级｜7x24小时运维保障</div>
              </div>
            </div>
            <div class="swiper-slide">
              <img @click="to('aboutus')" src="https://1312339042.vod-qcloud.com/110f907evodcq1312339042/67fcac4a5145403692739925218/HNXx4S5K534A.gif"
                style="image-rendering: pixelated;cursor: pointer;width: 100%;height:110vh;" />
              <div style="position: absolute;bottom: 260px;color: #fff;left: calc((100% - 1400px) / 2)">
                <div style="font-size: 48px;">平台 + 应用 + 服务 = 用户价值</div>
                <div style="font-size: 24px;margin-top: 50px;opacity: 0.8;">我们深知，ToB价值的最大化源于扎实的平台底座、贴身的场景应用与可靠的全流程服务保障
                </div>
                <div style="font-size: 24px;margin-top: 10px;opacity: 0.8;">三者融合一体，构建持续进化的智能价值引擎</div>
              </div>
            </div>
          </template>
</div>
<div class="swiper-button-prev" style="top: auto;left: calc((100% - 1400px) / 2);bottom: 50px;z-index: 9999;">
</div>
<div class="swiper-button-next"
  style="top: auto;right: auto;left: calc((100% - 1280px) / 2);bottom: 50px;z-index: 9999;"></div>
</div>
<div style="height: 145px;position: absolute;bottom: 0px;background: rgb(0 0 0 / 50%);width: 100%;z-index: 99;">
  <div
    style="text-align: right;color: #fff;line-height: 145px;font-size: 30px;margin-right: calc((100% - 1300px) / 2);">
    {{ imgindex + 1 }}-3</div>
</div>
</div> -->
    <div style="position: relative;width: 100%;" :style="{ height: ispc ? '100vh' : 'auto' }">
      <img @click="to('AI')"
        src="https://1312339042.vod-qcloud.com/70030745vodsh1312339042/537c5e225145403692739094240/CYBiEWfks20A.gif"
        style="image-rendering: pixelated;cursor: pointer;width: 100%;" :style="{ height: ispc ? '100vh' : 'auto' }" />
      <div style="position: absolute;bottom: 100px;color: #fff;left: calc((100% - 1250px) / 2)">
        <div style="font-size: 48px;">AI大模型服务平台</div>
        <div style="font-size: 48px;">适配于DeepSeek大模型</div>
        <div style="font-size: 24px;margin-top: 50px;opacity: 0.8;">驱动企业智能化深度变革，释放数据价值，重塑业务增长引擎</div>
      </div>
    </div>
    <div style="position: relative;"><img src="../../assets/home/home-bj.png" style="position: absolute;width: 100%;"></div>
    <div style="width: 1200px;margin: 0px auto;margin-top: 100px;position: relative;border-radius: 10px;">
      <div id="homemenu">
        <div @mouseenter="tindex = 0" @click="tindex = 0" :class="{ 'ttitle': tindex == 0 }">AI产品</div>
        <div @mouseenter="tindex = 1" @click="tindex = 2" :class="{ 'ttitle': tindex == 1 }">标准产品</div>
        <div @mouseenter="tindex = 2" @click="tindex = 3" :class="{ 'ttitle': tindex == 2 }">定制应用</div>
      </div>

      <div
        style="border-radius: 10px;margin-top: 30px;background: #fff;box-shadow:rgb(223 223 223 / 50%) 0px 15px 20px 0px;padding: 35px 0px;">
        <div id="homeapp">
          <div v-show="tindex == 0">
            <transition name="qweqwe">
              <div v-if="tindex == 0" style="display: flex;justify-content: center;">
                <div style="height: 300px;width: 200px;" class="lifors pointer" @click="tof('AI知识库')">
                  <div style="margin-top: 20px;"><img src="../../assets/home/ai1@2x.png"
                      style="margin:0px auto;height: 50px;">
                  </div>
                  <div style="font-size: 18px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                    AI知识库</div>
                  <div style="padding-top: 10px;">
                    <div class="homeappbutton">智能数据引擎</div>
                    <div class="homeappbutton">多模态洞察</div>
                    <div class="homeappbutton">资产增值</div>
                  </div>
                  <!-- <div style="font-size: 16px;margin-top: 30px;line-height: 30px;color: #666666;">
                    企业级智能数据引擎,整合多模态信息生成可行动洞察，破解信息孤岛，驱动数据资产升级为增长动力源
                  </div> -->
                </div>
                <div style="width: 1px;background: rgb(240, 240, 240);height: 280px;margin: 0px 18px;"></div>
                <div style="height: 300px;width: 200px;" class="lifors pointer" @click="tof('AI智能客服')">
                  <div style="margin-top: 20px;"><img src="../../assets/home/ai2@2x.png"
                      style="margin:0px auto;height: 50px;">
                  </div>
                  <div style="font-size: 18px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                    AI智能客服</div>
                  <div style="padding-top: 10px;">
                    <div class="homeappbutton">生成式对话</div>
                    <div class="homeappbutton">情绪识别</div>
                    <div class="homeappbutton">业务联动</div>
                  </div>
                  <!-- <div style="font-size: 16px;margin-top: 30px;line-height: 30px;color: #666666;">
                    生成式AI全渠道对话引擎，支持情绪识别与业务系统联动生成解决方案，显著提升问题解决率
                  </div> -->
                </div>
                <div style="width: 1px;background: rgb(240, 240, 240);height: 280px;margin: 0px 18px;"></div>
                <div style="height: 300px;width: 200px;" class="lifors pointer" @click="tof('AI智慧党建')">
                  <div style="margin-top: 20px;"><img src="../../assets/home/ai3@2x.png"
                      style="margin:0px auto;height: 50px;">
                  </div>
                  <div style="font-size: 18px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                    AI智慧党建</div>
                  <div style="padding-top: 10px;">
                    <div class="homeappbutton">红色智能助手</div>
                    <div class="homeappbutton">智慧化赋能</div>
                    <div class="homeappbutton">标准规范</div>
                  </div>
                  <!-- <div style="font-size: 16px;margin-top: 30px;line-height: 30px;color: #666666;">
                    AI 深度融入政策解读、公文管理及党员服务全流程，打造高效精准的红色智能助手,赋能党建新动能
                  </div> -->
                </div>
                <div style="width: 1px;background: rgb(240, 240, 240);height: 280px;margin: 0px 18px;"></div>
                <div style="height: 300px;width: 200px;" class="lifors pointer" @click="tof('AI信息安全')">
                  <div style="margin-top: 20px;"><img src="../../assets/home/ai4@2x.png"
                      style="margin:0px auto;height: 50px;">
                  </div>
                  <div style="font-size: 18px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                    AI信息安全</div>
                  <div style="padding-top: 10px;">
                    <div class="homeappbutton">轻量化风控</div>
                    <div class="homeappbutton">智能响应</div>
                    <div class="homeappbutton">大模型防御</div>
                  </div>
                  <!-- <div style="font-size: 16px;margin-top: 30px;line-height: 30px;color: #666666;">
                    企微轻量化 AI 安全方案,通过大模型实现实时风险掌控智能报告生成与故障自动响应
                  </div> -->
                </div>
                <div style="width: 1px;background: rgb(240, 240, 240);height: 280px;margin: 0px 18px;"></div>
                <div style="height: 300px;width: 200px;" class="lifors pointer" @click="tof('AI舆情监测')">
                  <div style="margin-top: 20px;"><img src="../../assets/home/ai5@2x.png"
                      style="margin:0px auto;height: 50px;">
                  </div>
                  <div style="font-size: 18px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                    AI舆情监测</div>
                  <div style="padding-top: 10px;">
                    <div class="homeappbutton">全源风险洞察</div>
                    <div class="homeappbutton">机遇预警</div>
                    <div class="homeappbutton">实时决策</div>
                  </div>
                  <!-- <div style="font-size: 16px;margin-top: 30px;line-height: 30px;color: #666666;">
                    基于企业微信会话的实时舆情分析，挖掘客户员工与市场声量中的风险机遇，辅助智慧决策
                  </div> -->
                </div>
              </div>
            </transition>
          </div>
          <div v-show="tindex == 1">
            <transition name="qweqwe">
              <div v-if="tindex == 1" style="display: flex;justify-content: center;">
                <div>
                  <div style="margin-left: 10px;" class="cprimary fbold file falign">
                    <div style="width: 3px;height: 14px;margin-right:10px ;" class="bprimary"></div>协同办公
                  </div>
                  <div
                    style="margin-top: 15px;display: flex;flex-direction: column;flex-wrap: wrap;width: 474px;height: 330px;">
                    <div @click="tod('企业微信')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/xt1@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">企业微信</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">连接微信生态的企业协同中...</div>
                      </div>
                    </div>
                    <div @click="tod('效率套件')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/xt2@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">效率套件</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">融合邮箱、微盘、文档的...</div>
                      </div>
                    </div>
                    <div @click="tod('腾讯会议')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/xt3@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">腾讯会议</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">亿级用户信赖的智能云会议...</div>
                      </div>
                    </div>
                    <div @click="tod('腾讯文档')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/xt8@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">腾讯文档</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">智能云端协作文档平台</div>
                      </div>
                    </div>
                    <div @click="tod('腾讯问卷')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/xt5@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">腾讯问卷</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">专业调研数据收集工具</div>
                      </div>
                    </div>
                    <div @click="tod('腾讯乐享')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/xt4@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">腾讯乐享</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">一站式企业知识社区平台</div>
                      </div>
                    </div>
                    <div @click="tod('腾讯电子签')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/xt7@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">腾讯电子签</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">10秒签约，具备法律效力</div>
                      </div>
                    </div>
                    <div @click="tod('TAPD敏捷项目管理')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/xt6@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">TAPD敏捷项目管理</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">一站式敏捷研发协作平台</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="width: 1px;background: rgb(240, 240, 240);height: 335px;margin: 0px 10px;"></div>
                <div>
                  <div style="margin-left: 10px;" class="cprimary fbold file falign">
                    <div style="width: 3px;height: 14px;margin-right:10px ;" class="bprimary"></div>客户服务
                  </div>
                  <div style="margin-top: 15px;display: flex;flex-direction: column;flex-wrap: wrap;height: 330px;">
                    <div @click="tod('腾讯企点')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/kh1@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">腾讯企点</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">全渠道智能客服营销平台</div>
                      </div>
                    </div>
                    <div @click="tod('腾讯微卡')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/kh2@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">腾讯微卡</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">全场景身份支付管理平台</div>
                      </div>
                    </div>
                    <div @click="tod('客服大模型机器人')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/kh3@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">客服大模型机器人</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">AI驱动智能客服机器人</div>
                      </div>
                    </div>
                    <div @click="tod('企点营销云')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/kh4@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">企点营销云</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">企点营销云</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="width: 1px;background: rgb(240, 240, 240);height: 335px;margin: 0px 10px;"></div>
                <div>
                  <div style="margin-left: 10px;" class="cprimary fbold file falign">
                    <div style="width: 3px;height: 14px;margin-right:10px ;" class="bprimary"></div>安全保障
                  </div>
                  <div style="margin-top: 15px;display: flex;flex-direction: column;flex-wrap: wrap;height: 330px;">
                    <div @click="tod('会话存档')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/aq1@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">会话存档</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">合规存档企业沟通记录</div>
                      </div>
                    </div>
                    <div @click="tod('数据保障')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/aq3@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">数据保障</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">企业数据备份恢复方案</div>
                      </div>
                    </div>
                    <div @click="tod('IOA零信任')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/aq2@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">IOA零信任</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">动态鉴权，保障全域安全</div>
                      </div>
                    </div>
                    <div @click="tod('企业网盘')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/aq4@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">企业网盘</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">安全高效企业文件管理</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="width: 1px;background: rgb(240, 240, 240);height: 335px;margin: 0px 10px;"></div>
                <div>
                  <div style="margin-left: 10px;" class="cprimary fbold file falign">
                    <div style="width: 3px;height: 14px;margin-right:10px ;" class="bprimary"></div>国产化方案
                  </div>
                  <div style="margin-top: 15px;display: flex;flex-direction: column;flex-wrap: wrap;height: 330px;">
                    <div @click="tod('企微私有化（信创版）')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/gch1@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">企微私有化（信创版）</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">企业微信私有部署方案</div>
                      </div>
                    </div>
                    <div @click="tod('腾讯会议混合云')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/gch2@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">腾讯会议混合云</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">混合部署会议解决方案</div>
                      </div>
                    </div>
                    <div @click="tod('TencentOS Server')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/gch3@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">TencentOS Server</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">腾讯自研AI增强型操作系统</div>
                      </div>
                    </div>
                    <div @click="tod('分布式数据库TDSQL')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/gch4@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">分布式数据库TDSQL</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">高性能分布式数据库</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <div v-show="tindex == 2">
            <transition name="qweqwe">
              <div v-if="tindex == 2" style="display: flex;justify-content: center;">
                <div>
                  <div style="margin-left: 10px;" class="cprimary fbold file falign">
                    <div style="width: 3px;height: 14px;margin-right:10px ;" class="bprimary"></div>精品应用
                  </div>
                  <div style="margin-top: 15px;display: flex;flex-direction: column;flex-wrap: wrap;height: 330px;">
                    <div @click="toc('SCRM私域运营系统')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/jp1@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">SCRM私域运营系统</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">微信生态全链路私域增长平台</div>
                      </div>
                    </div>
                    <div @click="toc('微信一体化服务平台')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/jp2@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">微信一体化服务平台</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">企业微信+公众号统一管理中枢</div>
                      </div>
                    </div>
                    <div @click="toc('会话存档助手')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/jp3@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">会话存档助手</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">会话智能存管与风控平台</div>
                      </div>
                    </div>
                    <div @click="toc('会议助手')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/jp4@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">会议助手</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">全流程智能会议协同助手</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="width: 1px;background: rgb(240, 240, 240);height: 335px;margin: 0px 15px;"></div>
                <div>
                  <div style="margin-left: 10px;" class="cprimary fbold file falign">
                    <div style="width: 3px;height: 14px;margin-right:10px ;" class="bprimary"></div>移动办公
                  </div>
                  <div
                    style="margin-top: 15px;display: flex;flex-direction: column;flex-wrap: wrap;height: 330px;width: 420px;">
                    <div @click="toc('员工考勤')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/yd1@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">员工考勤</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">智能移动考勤闭环管理</div>
                      </div>
                    </div>
                    <div @click="toc('流程审批')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/yd2@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">流程审批</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">全流程电子审批规则引擎</div>
                      </div>
                    </div>
                    <div @click="toc('公文管理')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/yd3@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">公文管理</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">公文全流程规范管控</div>
                      </div>
                    </div>
                    <div @click="toc('任务管理')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/yd4@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">任务管理</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">任务协同追踪可视化管理</div>
                      </div>
                    </div>
                    <div @click="toc('用车管理')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/yd5@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">用车管理</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">公车智能管控全周期方案</div>
                      </div>
                    </div>
                    <div @click="toc('资产管理')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/yd6@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">资产管理</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">资产全生命周期精益管理</div>
                      </div>
                    </div>
                    <div @click="toc('日程安排')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/yd7@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">日程安排</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">多端智能日程协同规划</div>
                      </div>
                    </div>
                    <div @click="toc('工地巡检')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/yd8@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">工地巡检</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">移动巡检隐患闭环管理</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="width: 1px;background: rgb(240, 240, 240);height: 335px;margin: 0px 15px;"></div>
                <div>
                  <div style="margin-left: 10px;" class="cprimary fbold file falign">
                    <div style="width: 3px;height: 14px;margin-right:10px ;" class="bprimary"></div>企业服务
                  </div>
                  <div style="margin-top: 15px;display: flex;flex-direction: column;flex-wrap: wrap;height: 330px;">
                    <div @click="toc('访客预约')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/qy1@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">访客预约</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">访客全流程智能通行管控</div>
                      </div>
                    </div>
                    <div @click="toc('培训考试')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/qy2@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">培训考试</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">轻量化在线学习考核平台</div>
                      </div>
                    </div>
                    <div @click="toc('食堂报餐')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/qy3@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">食堂报餐</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">智慧食堂报餐管理工具</div>
                      </div>
                    </div>
                    <div @click="toc('岗位竞聘')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/qy4@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">岗位竞聘</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">内部竞聘数字化流转平台</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="width: 1px;background: rgb(240, 240, 240);height: 335px;margin: 0px 15px;"></div>
                <div>
                  <div style="margin-left: 10px;" class="cprimary fbold file falign">
                    <div style="width: 3px;height: 14px;margin-right:10px ;" class="bprimary"></div>智慧校园
                  </div>
                  <div style="margin-top: 15px;display: flex;flex-direction: column;flex-wrap: wrap;height: 330px;">
                    <div @click="toc('教室预定')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/xy1@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">教室预定</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">高校自习室数字化预订系统</div>
                      </div>
                    </div>
                    <div @click="toc('活动报名')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/xy2@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">活动报名</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">校园活动全链路参与平台</div>
                      </div>
                    </div>
                    <div @click="toc('校友捐赠')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/xy3@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">校友捐赠</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">校友捐赠透明化管理平台</div>
                      </div>
                    </div>
                    <div @click="toc('故障报修')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img src="../../assets/home/xy4@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">故障报修</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">响应式在线报修闭环系统</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
        <div v-if="tindex !== 0" @click="toe" class="buttondh"
          style="margin: 0px auto;width: 120px;height: 36px;line-height: 36px;text-align: center;border: 1px solid #1e66d1;border-radius: 10px;font-size: 14px;color: #1e66d1;cursor: pointer;">
          查看更多 >
        </div>
      </div>
    </div>
    <div style="margin-top: 100px;position: relative;">
      <div style="position: relative;z-index: 9;">
        <div style="font-size: 40px;text-align: center;">视频介绍</div>
        <div
          style="margin: 0px auto;margin-top: 40px;width: 1200px;overflow-x: hidden;position: relative;height: 625px;">
          <div style="width: 4800px;display: flex;position: absolute;top: 0px;"
            :style="'transition:all 1s;left: ' + left + 'px;'">
            <div style="width: 1200px;display: flex;flex-wrap: wrap;" v-for="w in mp4">
              <div v-for="x in w" @click="videoShowFun(x)"
                style="cursor: pointer;width: 380px;margin:0px 10px;margin-bottom: 30px;" class="lifors">
                <div><img :src="x.img" style="border-radius: 10px;"></div>
                <div style="margin-top: 15px;">{{ x.title }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="videobutton">
          <div @click="left = 0; videobindex = 1;" :style="{ background: videobindex == 1 ? '#1e66d1 !important' : '#d5d5d5' }">
          </div>
          <div @click="left = -1200; videobindex = 2;" :style="{ background: videobindex == 2 ? '#1e66d1 !important' : '#d5d5d5' }">
          </div>
          <div @click="left = -2400; videobindex = 3;" :style="{ background: videobindex == 3 ? '#1e66d1 !important' : '#d5d5d5' }">
          </div>
          <div @click="left = -3600; videobindex = 4;" :style="{ background: videobindex == 4 ? '#1e66d1 !important' : '#d5d5d5' }">
          </div>
        </div>
        <!-- <div class="buttondh"
          style="margin: 0px auto;width: 120px;height: 36px;line-height: 36px;text-align: center;border: 1px solid #1e66d1;border-radius: 10px;font-size: 14px;color: #1e66d1;cursor: pointer;">
          查看更多 >
        </div> -->
      </div>
      <img src="../../assets/images/index4.png" style="position: absolute;bottom: -350px;opacity: 0.3;">
    </div>
    <div style="margin-top: 100px;position: relative;">
      <div style="font-size: 40px;text-align: center;">为各行业提供全栈解决方案</div>
      <div style="margin: 0px auto;margin-top: 60px;width: 1200px;display: flex;justify-content: space-between;"
        id="homejjfz">
        <div
          style="width: 240px;height: 440px;font-size: 14px;background: #1e66d1;color: #fff;padding:28px 15px;border-radius: 15px;">
          <div @mouseenter="hjindex = 1" @click="hjindex = 1" style="display: flex;justify-content:space-between;align-items: center;height: 48px;border-radius: 10px;
          padding:0px 5px 0px 15px;cursor: pointer;border: 0px solid transparent;" :class="{ 'hjmenu': hjindex == 1 }">
            <div><img src="../../assets/home/hylei-1.png" style="width: 30px;height: 30px;"></div>
            <div>教育行业</div>
            <div style="width: 10px;"><label v-show="hjindex == 1">></label></div>
          </div>
          <div @mouseenter="hjindex = 2" @click="hjindex = 2" style="display: flex;justify-content:space-between;align-items: center;height: 48px;border-radius: 10px;
          padding:0px 5px 0px 15px;cursor: pointer;border: 0px solid transparent;" :class="{ 'hjmenu': hjindex == 2 }">
            <div><img src="../../assets/home/hylei-2.png" style="width: 30px;height: 30px;"></div>
            <div>制造行业</div>
            <div style="width: 10px;"><label v-show="hjindex == 2">></label></div>
          </div>
          <div @mouseenter="hjindex = 3" @click="hjindex = 3" style="display: flex;justify-content:space-between;align-items: center;height: 48px;border-radius: 10px;
          padding:0px 5px 0px 15px;cursor: pointer;border: 0px solid transparent;" :class="{ 'hjmenu': hjindex == 3 }">
            <div><img src="../../assets/home/hylei-3.png" style="width: 30px;height: 30px;"></div>
            <div>设计院</div>
            <div style="width: 10px;"><label v-show="hjindex == 3">></label></div>
          </div>
          <div @mouseenter="hjindex = 4" @click="hjindex = 4" style="display: flex;justify-content:space-between;align-items: center;height: 48px;border-radius: 10px;
          padding:0px 5px 0px 15px;cursor: pointer;border: 0px solid transparent;" :class="{ 'hjmenu': hjindex == 4 }">
            <div><img src="../../assets/home/hylei-4.png" style="width: 30px;height: 30px;"></div>
            <div>零售行业</div>
            <div style="width: 10px;"><label v-show="hjindex == 4">></label></div>
          </div>
          <div @mouseenter="hjindex = 5" @click="hjindex = 5" style="display: flex;justify-content:space-between;align-items: center;height: 48px;border-radius: 10px;
          padding:0px 5px 0px 15px;cursor: pointer;border: 0px solid transparent;" :class="{ 'hjmenu': hjindex == 5 }">
            <div><img src="../../assets/home/hylei-5.png" style="width: 30px;height: 30px;"></div>
            <div>金融行业</div>
            <div style="width: 10px;"><label v-show="hjindex == 5">></label></div>
          </div>
          <div @mouseenter="hjindex = 6" @click="hjindex = 6" style="display: flex;justify-content:space-between;align-items: center;height: 48px;border-radius: 10px;
          padding:0px 5px 0px 15px;cursor: pointer;border: 0px solid transparent;" :class="{ 'hjmenu': hjindex == 6 }">
            <div><img src="../../assets/home/hylei-6.png" style="width: 30px;height: 30px;"></div>
            <div>医药行业</div>
            <div style="width: 10px;"><label v-show="hjindex == 6">></label></div>
          </div>
          <div @mouseenter="hjindex = 7" @click="hjindex = 7" style="display: flex;justify-content:space-between;align-items: center;height: 48px;border-radius: 10px;
          padding:0px 5px 0px 15px;cursor: pointer;border: 0px solid transparent;" :class="{ 'hjmenu': hjindex == 7 }">
            <div><img src="../../assets/home/hylei-7.png" style="width: 30px;height: 30px;"></div>
            <div>集团企业</div>
            <div style="width: 10px;"><label v-show="hjindex == 7">></label></div>
          </div>
          <div @mouseenter="hjindex = 8" @click="hjindex = 8" style="display: flex;justify-content:space-between;align-items: center;height: 48px;border-radius: 10px;
          padding:0px 5px 0px 15px;cursor: pointer;border: 0px solid transparent;" :class="{ 'hjmenu': hjindex == 8 }">
            <div><img src="../../assets/home/hylei-8.png" style="width: 30px;height: 30px;"></div>
            <div>政务行业</div>
            <div style="width: 10px;"><label v-show="hjindex == 8">></label></div>
          </div>
        </div>
        <div style="width: 945px;height: 440px;color: #fff;position: relative;">
          <div style="width: 100%;height: 100%;position: absolute;left: 0px;top: 0px;"
            :style="[{ backgroundImage: 'url(' + require('@/assets/home/hy1.png') + ')' }, { opacity: hjindex == 1 ? 1 : 0 }]">
            <transition name="oxyshow">
              <div style="padding: 50px;" v-if="hjindex == 1">
                <div style="font-size: 28px;">一体化平台赋能教学管理与服务升级</div>
                <div style="padding:60px 0px;">
                  <div><label style="margin-right: 15px;">★</label>教学数据分散难整合，决策缺乏依据</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>行政流程繁琐低效，资源调配滞后</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>师生服务体验割裂，反馈响应迟缓</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>跨场景协作壁垒高，信息互通困难</div>
                </div>
              </div>
            </transition>
          </div>
          <div style="width: 100%;height: 100%;position: absolute;left: 0px;top: 0px;"
            :style="[{ backgroundImage: 'url(' + require('@/assets/home/hy2.png') + ')' }, { opacity: hjindex == 2 ? 1 : 0 }]">
            <transition name="oxyshow">
              <div style="padding: 50px;" v-if="hjindex == 2">
                <div style="font-size: 28px;">云端协同驱动敏捷制造与精准触达</div>
                <div style="padding:60px 0px;">
                  <div><label style="margin-right: 15px;">★</label>生产数据孤立不透明，过程管控盲区多</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>设备运维依赖人工，故障响应效率低</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>跨部门协同成本高，资源调度不敏捷</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>能耗与废品率居高，绿色转型压力大</div>
                </div>
              </div>
            </transition>
          </div>
          <div style="width: 100%;height: 100%;position: absolute;left: 0px;top: 0px;"
            :style="[{ backgroundImage: 'url(' + require('@/assets/home/hy3.png') + ')' }, { opacity: hjindex == 3 ? 1 : 0 }]">
            <transition name="oxyshow">
              <div style="padding: 50px;" v-if="hjindex == 3">
                <div style="font-size: 28px;">统一平台赋能设计协同与移动办公</div>
                <div style="padding:60px 0px;">
                  <div><label style="margin-right: 15px;">★</label>项目流程割裂，跨专业协作效率低</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>知识资产分散流失，经验复用困难</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>审签依赖线下，进度延迟风险高</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>数据安全管控弱，合规隐患突出</div>
                </div>
              </div>
            </transition>
          </div>
          <div style="width: 100%;height: 100%;position: absolute;left: 0px;top: 0px;"
            :style="[{ backgroundImage: 'url(' + require('@/assets/home/hy4.png') + ')' }, { opacity: hjindex == 4 ? 1 : 0 }]">
            <transition name="oxyshow">
              <div style="padding: 50px;" v-if="hjindex == 4">
                <div style="font-size: 28px;">全链路数字化融合，智能驱动人货场</div>
                <div style="padding:60px 0px;">
                  <div><label style="margin-right: 15px;">★</label>客流转化率低，精准营销能力不足</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>线上线下库存割裂，供需匹配失衡</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>供应链响应迟缓，成本控制难度大</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>消费行为洞察弱，体验优化无依据</div>
                </div>
              </div>
            </transition>
          </div>
          <div style="width: 100%;height: 100%;position: absolute;left: 0px;top: 0px;"
            :style="[{ backgroundImage: 'url(' + require('@/assets/home/hy5.png') + ')' }, { opacity: hjindex == 5 ? 1 : 0 }]">
            <transition name="oxyshow">
              <div style="padding: 50px;" v-if="hjindex == 5">
                <div style="font-size: 28px;">数字化赋能金融客户服务与智能风控</div>
                <div style="padding:60px 0px;">
                  <div><label style="margin-right: 15px;">★</label>风控依赖人工，异常交易响应滞后</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>客户服务流程冗长，体验满意度低</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>业务数据孤岛化，营销精准度不足</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>合规审计效率低，人为操作风险高</div>
                </div>
              </div>
            </transition>
          </div>
          <div style="width: 100%;height: 100%;position: absolute;left: 0px;top: 0px;"
            :style="[{ backgroundImage: 'url(' + require('@/assets/home/hy6.png') + ')' }, { opacity: hjindex == 6 ? 1 : 0 }]">
            <transition name="oxyshow">
              <div style="padding: 50px;" v-if="hjindex == 6">
                <div style="font-size: 28px;">全场景方案保障，合规生产提质效</div>
                <div style="padding:60px 0px;">
                  <div><label style="margin-right: 15px;">★</label>质量追溯链条断裂，合规成本高昂</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>生产与研发数据脱节，良品率波动大</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>供应链温控监管难，流通安全风险高</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>文档管理效率低下，审计响应速度慢</div>
                </div>
              </div>
            </transition>
          </div>
          <div style="width: 100%;height: 100%;position: absolute;left: 0px;top: 0px;"
            :style="[{ backgroundImage: 'url(' + require('@/assets/home/hy7.png') + ')' }, { opacity: hjindex == 7 ? 1 : 0 }]">
            <transition name="oxyshow">
              <div style="padding: 50px;" v-if="hjindex == 7">
                <div style="font-size: 28px;">统一管控平台驱动集团协同提效能</div>
                <div style="padding:60px 0px;">
                  <div><label style="margin-right: 15px;">★</label>多业态数据割裂，战略协同效率低</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>审批流程层级冗长，决策周期缓慢</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>资源分散难共享，整体成本居高</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>客户管理分散，价值挖掘不充分</div>
                </div>
              </div>
            </transition>
          </div>
          <div style="width: 100%;height: 100%;position: absolute;left: 0px;top: 0px;"
            :style="[{ backgroundImage: 'url(' + require('@/assets/home/hy8.png') + ')' }, { opacity: hjindex == 8 ? 1 : 0 }]">
            <transition name="oxyshow">
              <div style="padding: 50px;" v-if="hjindex == 8">
                <div style="font-size: 28px;">安全云平台赋能，打通协作提服务</div>
                <div style="padding:60px 0px;">
                  <div><label style="margin-right: 15px;">★</label>教学数据分散难整合，决策缺乏依据</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>公共服务响应慢，群众满意度低 </div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>审批流程繁复，一网通办落地难 </div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>数据安全风险高，治理透明度不足</div>
                </div>
              </div>
            </transition>
          </div>
          <div style="display: flex;position: absolute;left: 50px;bottom: 60px;">
            <div @click="tob" class="lifors"
              style="width: 120px;height: 36px;line-height: 36px;text-align: center;border-radius: 20px;font-size: 14px;color: #fff;cursor: pointer;background: #1e66d1;">
              立即咨询
            </div>
            <div @click="toa" class="lifors"
              style="margin-left: 10px; width: 120px;height: 36px;line-height: 36px;text-align: center;border-radius: 20px;font-size: 14px;color: #fff;cursor: pointer;background: #728097;">
              如何解决
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="position: relative;margin-top: 150px;">
      <div style="font-size: 40px;font-weight: normal;text-align: center;">合作案例</div>
      <div style="padding-top: 40px;">
        <div class="mendiv">
          <div @mouseenter="setapps(i)" @click="setapps(i)" class="pointer hprimary" v-for="(x, i) in menus"
            :class="{ 'mtitle': i == mindex }">
            {{
              x.name
            }}</div>
        </div>
      </div>
    </div>
    <div style="background: #f5f7fa;padding-bottom: 20px;">
      <div class="hezuoanlie"
        style="display: flex;flex-wrap: wrap;width: 1200px;justify-content: center;margin: 0px auto;justify-content:space-between;padding:35px 0px;">
        <div v-show="x.img" style="margin: 10px 0px;padding: 0px 0px;background: #fff;width: 23%;"
          v-for="(x, i) in apps" :key="i">
          <img style="width: 100%;" :src="action + x.img">
        </div>
      </div>
    </div>
    <div v-if="videoShow" @click="videoShow = false"
      style="position: fixed;width: 100%;height: 100%;top: 0px;left: 0px;background: rgb(0 0 0 / 50%);z-index: 999999999;">
      <div @click.stop="videoShow = true"
        style="position: absolute;width: 1000px;top: 50%;left: 50%;transform: translate(-50%, -50%);cursor: pointer;">
        <video class="videosss" preload="auto"
          style="border-radius: 10px;background: #333;padding: 20px;width: 1000px;max-height: 80vh;" controls autoplay
          :poster="mp4obj.img">
          <source :src="mp4obj.video" type="video/mp4">
        </video>
        <img @click="videoShow = false" style="right: -0px;position: absolute;top: -0px;width: 35px;height: 35px;" src="../../assets/home/delete.png"></img>
        <!-- <div style="right: 0px;position: absolute;top: 10px;width: 50px;height: 50px;font-size: 16px;color: #fff;">关闭</div> -->
      </div>
    </div>
  </div>
</template>
<script>
import 'swiper/swiper-bundle.css'
// import { Swiper } from "swiper"
// import { Autoplay, Pagination, Navigation } from "swiper/modules"
import { getJsonTree } from '@/utils/index'
export default {
  data() {
    return {
      ispc: true,
      show: true,
      showb: false,
      showc: false,
      index: 0,
      tindex: 1,
      hjindex: 1,
      action: '',
      mindex: 0,
      menus: [],
      apps: [],
      imgindex: 0,
      videoShow: false,
      mp4obj: {},
      videobindex: 1,
      left: 0,
      mp4: [[
        { title: '公司服务介绍', img: require("../../assets/mp4/视频封面1.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/184c4f5a5145403694073440442/v.f100800.mp4' },
        { title: '企业信息化选型之路', img: require("../../assets/mp4/视频封面2.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/f4d45b415145403694385120952/v.f100800.mp4' },
        { title: 'AI知识库', img: require("../../assets/mp4/视频封面3.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/6bc392895145403694067964236/v.f100800.mp4' },
        { title: 'AI智慧党建', img: require("../../assets/mp4/视频封面4.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/eb18ef125145403694062998657/v.f100800.mp4' },
        { title: 'AI信息安全', img: require("../../assets/mp4/视频封面5.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/fc1d30415145403694069528014/v.f100800.mp4' },
        { title: 'AI智能客服', img: require("../../assets/mp4/视频封面19.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/3525dae35145403695701168913/v.f100800.mp4' },
      ], [
        { title: 'AI+企业微信会话记录', img: require("../../assets/mp4/视频封面20.png"), video: 'https://1312339042.vod-qcloud.com/46ecf4edvodtranssh1312339042/683eb6b65145403699875378706/v.f100800.mp4' },
        { title: '快速搭建AI智能应用', img: require("../../assets/mp4/视频封面21.png"), video: 'https://1312339042.vod-qcloud.com/46ecf4edvodtranssh1312339042/36cf95315145403699871499260/v.f100800.mp4' },
        { title: '腾讯智能体开发平台', img: require("../../assets/mp4/视频封面22.png"), video: 'https://1312339042.vod-qcloud.com/46ecf4edvodtranssh1312339042/267361275145403707757025974/v.f100800.mp4' },
        { title: '企业级AI应用落地案例', img: require("../../assets/mp4/视频封面23.png"), video: 'https://1312339042.vod-qcloud.com/46ecf4edvodtranssh1312339042/0631fc545145403712979891758/v.f100800.mp4' },
        { title: '私域助手', img: require("../../assets/mp4/视频封面6.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/3812920c5145403694063997309/v.f100800.mp4' },
        { title: '智慧校园方案', img: require("../../assets/mp4/视频封面7.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/22ffe3205145403694063083527/v.f100800.mp4' },
      ], [
        { title: '场馆预约系统', img: require("../../assets/mp4/视频封面8.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/b940588d5145403694075740987/v.f100800.mp4' },
        { title: '统一支付对账系统', img: require("../../assets/mp4/视频封面9.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/4b4a93fb5145403694291915110/v.f100800.mp4' },
        { title: '食堂点餐系统', img: require("../../assets/mp4/视频封面10.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/7f449ccf5145403694295923676/v.f100800.mp4' },
        { title: '校友捐赠系统', img: require("../../assets/mp4/视频封面11.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/b7c143c85145403694296097504/v.f100800.mp4' },
        { title: '故障报修系统', img: require("../../assets/mp4/视频封面12.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/cc87216b5145403694296963028/v.f100800.mp4' },
        { title: '失物招领系统', img: require("../../assets/mp4/视频封面13.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/9dff9e655145403694078663270/v.f100800.mp4' },
      ], [
        { title: '自助迎新系统', img: require("../../assets/mp4/视频封面14.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/c8b5b1975145403694072302830/v.f100800.mp4' },
        { title: '疫情防控系统', img: require("../../assets/mp4/视频封面15.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/e0cd33295145403694293749027/v.f100800.mp4' },
        { title: '智慧党建系统', img: require("../../assets/mp4/视频封面18.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/9011a9de5145403694078071234/v.f100800.mp4' },
        { title: '访客预约系统', img: require("../../assets/mp4/视频封面16.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/b331f15f5145403694302472339/v.f100800.mp4' },
        { title: '用车管理系统', img: require("../../assets/mp4/视频封面17.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/ae3fd5b75145403694082041550/v.f100800.mp4' },
      ]],
      cards: [
        { img: require("../../assets/home/fa-1@3x.png"), title: '教育', text: '构建智慧校园平台，整合教学管理全场景，驱动数字化升级，显著提升教学与管理效能' },
        { img: require("../../assets/home/fa-2@3x.png"), title: '制造', text: '打造敏捷工业数字平台，实现生产全流程智能管控与协同，降本增效，加速智造转型' },
        { img: require("../../assets/home/fa-3@3x.png"), title: '设计院', text: '统一平台整合项目流程与知识资产，支持协同设计与审签，保障安全合规，缩短周期' },
        { img: require("../../assets/home/fa-4@3x.png"), title: '零售', text: '全链路数字化整合人货场，数据智能驱动精准营销与高效运营，优化体验与供应链' },
        { img: require("../../assets/home/fa-5@3x.png"), title: '金融', text: '覆盖客户全周期服务与智能风控，提升业务效率，优化体验，构建安全运营体系' },
        { img: require("../../assets/home/fa-6@3x.png"), title: '医药', text: '提供研发生产全场景方案，强化GMP合规与质量追溯，提升运营效率与管控水平' },
        { img: require("../../assets/home/fa-7@3x.png"), title: '集团', text: '打造数字化中枢平台，强化多业态协同与移动审批，优化资源配置，降低管理成本' },
        { img: require("../../assets/home/fa-8@3x.png"), title: '政务', text: '搭建安全政务云平台，打通跨部门协作与一网通办，提升治理响应与公众满意度' },
      ]
    }
  },
  created() {
    this.action = window['pathConfig'][process.env.NODE_ENV].ImgURL
    this.$http('/Plan/GetTypeData', { isall: 3 }).then(x => {
      if (x.data.length > 0) {
        var data = getJsonTree(x.data, '', 'pid')
        this.menus = data
        this.setapps(0)
        this.load()
      }
    })
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.ispc = false
    } else {
      this.ispc = true
    }
  },
  activated() {
  },
  mounted() {
  },
  methods: {
    to(name) {
      this.$router.push({ name: name })
    },
    toa() {
      this.$router.push({ name: 'solution', query: { index: this.hjindex - 1 } })
    },
    tob() {
      if (this.$isxj)
        window.open('https://work.weixin.qq.com/kfid/kfc54a4ebac7513c548')
      else
        window.open('https://work.weixin.qq.com/kfid/kfc31843ffccca81b46')
    },
    tod(title) {
      this.$router.push({ name: 'product', query: { title: title } })
    },
    toc(title) {
      this.$router.push({ name: 'app', query: { title: title } })
    },
    toe() {
      if (this.tindex == 1)
        this.$router.push({ name: 'product' })
      else if (this.tindex == 2)
        this.$router.push({ name: 'app' })
    },
    tof(title) {
      this.$router.push({ name: 'AIMenu', query: { title: title } })
    },
    videoShowFun(x) {
      this.mp4obj = x
      this.videoShow = true
    },
    setapps(i) {
      this.mindex = i
      this.apps = this.menus[i].children
    },
    load() {
      // var swiper = new Swiper(".banner-swiper", {
      //   modules: [Autoplay, Pagination, Navigation],
      //   // 循环模式
      //   loop: true,

      //   // 前进后退按钮
      //   navigation: {
      //     nextEl: ".swiper-button-next",
      //     prevEl: ".swiper-button-prev",
      //   },

      //   // 自动播放
      //   autoplay: {
      //     delay: 1000000,
      //     disableOnInteraction: false,
      //   },
      // })

      // var _this = this
      // swiper.on("slideChange", () => {
      //   const realIndex = swiper.realIndex
      //   _this.imgindex = realIndex
      // })
    }
  }
}
</script>
<style>
#home .mendiv {
  display: flex;
  justify-content: center;
}

#home .mtitle {
  font-size: 16px;
  color: #1e66d1 !important;
  font-weight: bold;
  border-bottom: 2px solid #1e66d1;
}

#home .mendiv div {
  padding: 0px 15px 18px 15px;
  margin: 0px 5px;
  font-size: 16px;
  color: #666;
}

#home .banner-swiper {
  position: relative;
  overflow: hidden;
}

.banner-swiper .swiper-button-prev,
.banner-swiper .swiper-button-next {
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  color: #333;

  width: 50px;
  height: 50px;
}

.banner-swiper .swiper-button-prev:after,
.banner-swiper .swiper-button-next:after {
  font-size: 20px;
  font-weight: bold;
}

.whyus-swiper {
  position: relative;
  overflow: hidden;
}

.whyus-item {
  transition: all 0.3s ease-in-out;
  text-align: center;
  padding: 2.5rem 1rem;
  background-color: #f2f3f5;
  flex: 1;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.whyus-item:after {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  content: "";
  display: block;
  height: 4px;
  width: 100%;
  opacity: 0;
  background-color: var(--color-primary);
  transition: opacity 0.3s ease-in-out;
}

.whyus-item.active {
  background-color: #f8f9fa;
}

.whyus-item.active:after {
  opacity: 1;
}

.whyus-item:hover {
  background-color: #f8f9fa;
}

.whyus-item:hover:after {
  opacity: 1;
}

.whyus-item h3 {
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.whyus-item p {
  color: #4b5563;
  line-height: 1.75;
  white-space: pre-line;
}

.slogan-text-font {
  font-size: 36px;
  display: flex;
  align-items: center;
}

.slogan-detail-card-title {
  font-size: 20px;
  display: relative;
}

.slogan-card {
  color: var(--color-content1);
  display: flex;
  height: 250px;
  width: 200px;
  flex-direction: column;
  align-items: center;
  border-radius: 1rem;
  background-color: rgb(255 255 255 / 0.8);
  padding-top: 2rem;
  padding-bottom: 2rem;
  font-size: 0.875rem;
  line-height: 1.75rem;
}

::v-deep #content p {
  text-indent: 2em;
  line-height: 35px;
  font-size: 16px;
}

::v-deep #content p:nth-child(2) {
  margin-top: 35px;
}

::v-deep #content p:nth-child(3) {
  margin-top: 35px;
}

.ai-yycj .div {
  width: 300px;
  height: 60px;
  line-height: 60px;
  font-size: 16px;
  text-align: center;
  border-radius: 15px 15px 0px 0px;
  cursor: pointer;
}

.ai-yycj .isdiv {
  font-weight: bold;
  background: #1e66d1;
  color: #fff;
}

.ai-gnzs div {
  width: 160px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  font-size: 18px;
  color: #999999;
  background: #ebebeb;
  margin-bottom: 10px;
  border-radius: 10px;
  cursor: pointer;
}

.ai-gnzs .isdiv {
  background: #fff;
  color: #333;
}

#homemenu {
  font-size: 18px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

#homemenu div {
  padding: 0px 35px;
  padding-bottom: 4px;
}

#homemenu .ttitle {
  font-size: 40px;
  padding-bottom: 0px;
  position: relative;
  cursor: pointer;
}

#homemenu .ttitle:after {
  content: '';
  position: absolute;
  left: 0px;
  right: 0px;
  margin: 0px auto;
  bottom: -30px;
  height: 4px;
  width: 100px;
  background-color: #1e66d1;
}

#homeapp .happ {
  border: 1px solid transparent;
  border-radius: 10px;
  /* width: 237px; */
  overflow-x: hidden;
  cursor: pointer;
  padding: 12px 8px !important;
}

#homeapp .happ:hover {
  background: #f9fbff;
  border: 1px solid #96bcf5;
}

#homejjfz .hjmenu {
  background: linear-gradient(90deg, #003f9d, #1e66d1);
  border: 0px solid rgb(47 131 255) !important;
}

.homeappbutton {
  margin: 0px auto;
  width: 165px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  border: 1px dashed #96bcf5;
  border-radius: 30px;
  font-size: 14px;
  background: #f8f8f8;
  margin-top: 10px;
}

.videobutton {
  display: flex;
  justify-content: center;
  align-items: center;
}

.videobutton div {
  height: 6px;
  width: 60px;
  cursor: pointer;
}

.videobutton div:hover {
  background: #1e66d183 !important;
}

@keyframes oxyshow {
  0% {
    opacity: 0;
    transform: translateX(50px);
  }

  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}

.oxyshow-enter-active {
  animation: oxyshow 1s ease-in-out;
}

/* .oxyshow-leave-active {
  animation: oxyshow 1s ease-in-out reverse;
} */

@keyframes qweqwe {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.qweqwe-enter-active {
  animation: qweqwe 0.5s ease-in-out;
}

/* .qweqwe-leave-active {
  animation: qweqwe 0s ease-in-out reverse;
} */

footer {
  --color-primary: #1e66d1;
}
</style>
